$(document).ready(function(){
  $('#CartByPass, #CartByPassCart').change(function() {
    if(this.checked) {
      data = {
        "id": 40878535475309,
        "quantity": 1,
      }
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() { 
          console.log('added');
         window.location.reload(); 
        }
      });
    } else {
      $('.cart__item[data-product="BYPASS MOQ (Not for sale)"] button.js-qty__adjust.js-qty__adjust--minus').click();
    }
  });
});